import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { AUTHORITY_INVOICE_STATUS } from 'constants/invoice';

const InvoiceReplaceModal = ({ invoice, visible, signedForm04, onCancel, ...rest }) => {
  const history = useHistory();
  const [t] = useTranslation();
  const { authority_status } = invoice;
  const sentDoT = authority_status === AUTHORITY_INVOICE_STATUS.SUCCESS;
  const isReadyCreateAdjust = !sentDoT || signedForm04;

  const redirectCancellationNotificationPage = () => {
    onCancel();
    history.push('/invoice/cancellation-notification/create');
  };

  React.useEffect(() => {
    if (isReadyCreateAdjust && visible) {
      onCancel();
      history.push(`/invoice/${invoice.id}/replace`);
    }
  }, [invoice, isReadyCreateAdjust, visible, history, onCancel]);

  if (isReadyCreateAdjust && visible) return <div />;
  return (
    <Modal
      okText={t('button.create-replace-notification')}
      cancelText={t('button.cancel')}
      title={t('invoice.action.replace')}
      onOk={redirectCancellationNotificationPage}
      visible={visible}
      onCancel={onCancel}
      {...rest}
    >
      <span>{t('invoice.replace.notification')}</span>
    </Modal>
  );
};

InvoiceReplaceModal.defaultProps = {
  visible: false,
  signedForm04: false,
  invoice: {},
  onOK: () => {},
  onCancel: () => {}
};

InvoiceReplaceModal.propTypes = {
  invoice: PropTypes.object,
  signedForm04: PropTypes.bool,
  visible: PropTypes.bool,
  onOK: PropTypes.func,
  onCancel: PropTypes.func
};

export default InvoiceReplaceModal;
